/* The House of Cobalt, quiz results ("Your regimen.", longevity anchor).
 *
 * The results page (snippets/page-results-body.liquid) renders all four goal
 * regimens server-side, with the Cellular Energy & NAD+ regimen visible by
 * default, so content is complete without JS. This script only:
 *   1. Reads the URL params written by the fitting (assets/quiz.js) and
 *      reveals the regimen matching ?goal= (cellular | aging | metabolic | sleep).
 *   2. Personalizes the hero eyebrow with ?name=.
 *   3. Wires the per-regimen "Add the full regimen" button
 *      ([data-rg2-add-all][data-variants]) to /cart/add.js, then opens the
 *      theme bag drawer (window.cobaltOpenCart from sections/header.liquid).
 *
 * Individual "Add to bag" buttons use the theme-wide [data-pc-add] delegation
 * in sections/header.liquid and need no wiring here. Loaded with `defer` on
 * every page; exits immediately when #rg2-root is absent.
 */
document.addEventListener('DOMContentLoaded', function () {
  var root = document.getElementById('rg2-root');
  if (!root) return;

  var qs = new URLSearchParams(window.location.search);
  var params = {};
  qs.forEach(function (v, k) { params[k] = v; });

  function first(str) {
    return String(str || '').split(',').map(function (s) { return s.trim(); })
      .filter(function (s) { return s && s !== 'none'; })[0] || '';
  }

  function pickRegimen(p) {
    var goal = (p.goal || '').trim();
    if (goal === 'cellular' || goal === 'aging' || goal === 'metabolic' || goal === 'sleep') return goal;
    // Fallbacks for links without ?goal= (older shares, direct visits with partial params)
    var focus = first(p.focus);
    var proto = first(p.protocol);
    if (focus === 'sleep' || proto === 'sleep-practice' || proto === 'recovery') return 'sleep';
    if (focus === 'metabolic' || proto === 'metabolic' || proto === 'rhythm') return 'metabolic';
    if (focus === 'structure' || focus === 'skin') return 'aging';
    if (focus === 'cellular' || focus === 'energy' || proto === 'nad' || proto === 'longevity') return 'cellular';
    return 'cellular'; // NAD+ is the house anchor
  }

  // 1. Reveal the matching regimen
  var key = pickRegimen(params);
  root.querySelectorAll('[data-regimen]').forEach(function (block) {
    block.hidden = block.getAttribute('data-regimen') !== key;
  });

  // 2. Personalization from the fitting (?name=)
  var fullName = (params.name || '').trim().replace(/\s+/g, ' ');
  if (fullName) {
    var firstName = fullName.split(' ')[0];
    var eyebrow = document.getElementById('rg2-eyebrow');
    if (eyebrow) eyebrow.textContent = firstName + ', your fitting is complete';
    var forWhom = document.getElementById('rg2-forwhom');
    if (forWhom) { forWhom.textContent = 'Curated for ' + fullName; forWhom.hidden = false; }
  }

  // 3. "Add the full regimen" buttons
  root.querySelectorAll('[data-rg2-add-all]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var ids = (btn.getAttribute('data-variants') || '').split(',')
        .map(function (s) { return parseInt(s.trim(), 10); })
        .filter(function (n) { return n > 0; });
      if (!ids.length) return;
      btn.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () {
          btn.classList.remove('is-loading');
          if (typeof window.cobaltOpenCart === 'function') window.cobaltOpenCart();
          else window.location.href = '/cart';
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          window.location.href = '/cart';
        });
    });
  });
});
